import React, { Component } from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from '@material-ui/core'
// import uuid from 'uuid/v4'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { connect } from 'react-redux'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import * as actions from '../../../../../store/actions'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class GradeTable extends Component {
  state = {
    gradeData: [],
    data: [],
    adjustData: []
  }

  static getDerivedStateFromProps (props, state) {
    if (typeof props.adjustData && typeof props.adjustData !== 'undefined') {
      if (props.gradeData !== state.gradeData) {
        let data = props.gradeData || props?.notData
        let grade = data.map(item => {
          return {
            ...item,
            budget_percent: parseInt(item.budget_percent) || 0,
            checkAmount: ~~(props.total * ((parseInt(item.budget_percent) || 0) / 100)),
            amount: ~~(props.total * ((parseInt(item.budget_percent) || 0) / 100)),
            id: item.value_list_id ? item.value_list_id : item.grade_id
          }
        })
        props.grade(grade, props.total)

        return {
          gradeData: props.gradeData,
          data: grade,
          CountForceRank: props.total
        }
      }
    }
    return null
  }

  inputChanged = (key, id, e) => {
    let updateData = this.state.data.map(item => {
      if (item.id === id) {
        if (key === 'budget') {
          let amount = ~~(this.state.CountForceRank * ((parseInt(e.target.value) || 0) / 100))
          return {
            ...item,
            budget_percent: parseInt(e.target.value) || 0,
            amount: amount,
            id: item.value_list_id ? item.value_list_id : item.grade_id
          }
        } else if (key === 'amount') {
          return {
            ...item,
            [key]: +parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : item[key]
          }
        }
      } else {
        return item
      }
      return item
    })
    this.props.grade(updateData, this.state.CountForceRank)
    this.setState({
      data: updateData
    })
  }

  sumBudget = () => {
    let sum = 0
    this.state.data.map(item => {
      sum = sum + item.budget_percent
      return item
    })
    return `${sum} (%)`
  }

  sumAmount = () => {
    let sum = 0
    this.state.data.map(item => {
      sum = sum + item.amount
      return item
    })

    return `${sum} (${this.state.CountForceRank ? this.state.CountForceRank : 0})`
  }

  render () {
    return (
      <Aux>
        <Paper>
          {this.state.data.length > 0 || this.props.unData ? (
            <TableContainer>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center'>{this.props.translate('grade')}</TableCell>
                    <TableCell align='center'>{this.props.translate('budget')} (%)</TableCell>
                    <TableCell align='center'>{this.props.translate('amount')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.data.map(row => (
                    <TableRow key={row.id}>
                      <TableCell align='center'>{row.value_list_name}</TableCell>
                      <TableCell align='center'>
                        <InputGroup
                          rows
                          inputType={'input'}
                          // configs={formWithOptions.elementConfig}
                          changed={e => this.inputChanged('budget', row.id, e)}
                          inputValue={row.budget_percent}
                          configs={{ endAdornment: '%' }}
                        />
                      </TableCell>
                      <TableCell align='center'>
                        {/* <InputGroup
                          inputType={'input'}
                          // configs={formWithOptions.elementConfig}
                          changed={e => this.inputChanged('amount', row.id, e)}
                          inputValue={row.amount}
                        /> */}
                        <InputGroup
                          inputType={'input'}
                          configs={{ type: 'number' }}
                          validations
                          invalid={
                            row.amount > +row.checkAmount + 1 || row.amount < +row.checkAmount - 1
                          }
                          touched
                          validationError={
                            row.amount > +row.checkAmount + 1 || row.amount < +row.checkAmount - 1
                              ? '+/- ไม่เกิน 1'
                              : ''
                          }
                          changed={e => this.inputChanged('amount', row.id, e)}
                          inputValue={row.amount}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell align='center'>{this.props.translate('total')}</TableCell>
                    <TableCell align='center'>{this.sumBudget()}</TableCell>
                    <TableCell align='center'>{this.sumAmount()}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
        </Paper>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.verticalForceRank.pagination,
    total: state.verticalForceRank.total,
    filters: state.verticalForceRank.filter,
    filtered: state.verticalForceRank.filtered,
    filterLoadingQueue: state.verticalForceRank.filterLoadingQueue,
    filterData: state.verticalForceRank.filterData,
    filterLoading: state.verticalForceRank.filterLoading,
    gradeData: state.verticalForceRank.gradeData,
    pageLoading:
      state.verticalForceRank.filterLoading || state.verticalForceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.verticalForceRank.filterCompanies,
      formFilterOptions: state.verticalForceRank.filterForms,
      // orgFilterOptions: state.verticalForceRank.filterOrgs
      frgFilterOptions: state.verticalForceRank.filterFrgs
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForceRankList: param => dispatch(actions.fetchReStoreVerticalForceRankList(param))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(GradeTable))
